import { render, staticRenderFns } from "./braceletForm.vue?vue&type=template&id=c6282d6e&scoped=true&"
import script from "./braceletForm.vue?vue&type=script&lang=js&"
export * from "./braceletForm.vue?vue&type=script&lang=js&"
import style0 from "./braceletForm.vue?vue&type=style&index=0&id=c6282d6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6282d6e",
  null
  
)

export default component.exports